import React, { useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const TicketAlertsForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!EMAIL_RE.test(value)) {
      setError("Please enter a valid email address.");
      return;
    }
    setError("");
    setStatus("loading");
    try {
      const res = await fetch(`${API}/api/ticket-alerts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: value }),
      });
      if (!res.ok) throw new Error("request failed");
      setStatus("done");
    } catch {
      setStatus("idle");
      setError("Something went wrong. Please try again.");
    }
  };

  if (status === "done") {
    return (
      <p id="ticket-alerts" className="bp-alerts-success" role="status" data-testid="ticket-alerts-success">
        Thanks — you’re on the list.
      </p>
    );
  }

  return (
    <form id="ticket-alerts" className="bp-alerts" onSubmit={submit} noValidate data-testid="ticket-alerts-form">
      <label id="ticket-alerts-label" htmlFor="bp-alerts-email" className="bp-alerts-label">Sign up for ticket alerts</label>
      <div className="bp-alerts-row">
        <input
          id="bp-alerts-email"
          type="email"
          name="email"
          autoComplete="email"
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-invalid={!!error}
          aria-describedby={error ? "bp-alerts-error" : undefined}
          className="bp-alerts-input"
          data-testid="ticket-alerts-email-input"
        />
        <button type="submit" className="bp-btn" disabled={status === "loading"} data-testid="ticket-alerts-submit">
          SIGN UP
        </button>
      </div>
      {error && (
        <p id="bp-alerts-error" className="bp-alerts-error" role="alert" data-testid="ticket-alerts-error">{error}</p>
      )}
    </form>
  );
};
